export enum ExportTypes {
	MASTERACCOUNT_AUDIT = 'maAudit',
	SYSTEM_AUDIT = 'audit'
}
